<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import PageHeader from "@/components/page-header";
import moment from "moment";
/**
 * Invoice-list component
 */
export default {
  page: {
    title: "Appointments Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader},
  data() {
    return {
      title: "Appointments Report",
      items: [
        {
          text: "Reports Section",
          href: "#",
        },
        {
          text: "Appointments Report",
          active: true,
        },
      ],
      sortBy: "id",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        
        {
          key: "photo",
          sortable: true,
          label: "PHOTO",
        },
        // {
        //   key: "branchName",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "name",
          sortable: true,
          label: "CLIENT NAME",
        },
        {
          key: "patient.patient_contact",
          sortable: true,
          label: "CLIENT CONTACT",
        },

        {
          key: "patient.patient_code",
          sortable: true,
          label: "CLIENT CODE",
        },
        {
          key: "doctor.staff_name",
          sortable: true,
          label: "DOCTOR NAME",
        },
        {
          key: "doctor.staff_contact",
          sortable: true,
          label: "DOCTOR CONTACT",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE & TIME",
        },
        {
          key: "addedBy",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "status",
          sortable: true,
          label: "STATUS",
        },
      ],
      fitered_array: [],
      filterreport: {
        title: "APPOINTMENTS REPORT",
        today: moment(new Date()).format("YYYY-MM-DD"),
        date1: '',
        statuscode: '',
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
    };
  },
  methods: {
    ...mapActions({
      appointmentsFetch: "appointment/fetchAppointmentsReport",
      FetchReturningPatients: "patients/fetchReturningPatients",
      FetchVillages: "patients/fetchVillages",
      FetchCountries: "countries/fetchCountries",
      FetchFacilities: "patients/fetchFacilities",
      FetchStaff: "staffModule/fetchClinicStaff",
    }),
    fill_report() {
      this.fitered_array = this.AppointmentsReport ? this.AppointmentsReport : [];
    },   
    // END SET COUNTRY CODE
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filter_report() {     
      
      this.fitered_array = this.AppointmentsReport;
      let startDate = this.filterreport.date1;
      let AppointmentStatus = this.filterreport.statuscode;
      let endDate = this.filterreport.date2;
      if (AppointmentStatus != "" && endDate != "") {            
        this.filterreport.title = "APPOINTMENTS REPORT FOR STATUS " + this.filterreport.statuscode;
        this.fitered_array = this.AppointmentsReport.filter((appt) => {       
          return appt.status == AppointmentStatus;
        });
      }
      else if (startDate != "" && endDate != "" && AppointmentStatus != "") {
        this.filterreport.title = "APPOINTMENTS REPORT FROM " + this.filterreport.date1 + " TO " + this.filterreport.date2 + " FOR STATUS " + this.filterreport.statuscode;
        this.fitered_array = this.AppointmentsReport.filter((appt) => {
          return appt.report_date >= startDate && appt.report_date <= endDate && appt.status == AppointmentStatus;
        });
      }
      else if (startDate != "" && endDate != "") {
        this.filterreport.title = "APPOINTMENTS REPORT FROM " + this.filterreport.date1 + " TO " + this.filterreport.date2;
        this.fitered_array = this.AppointmentsReport.filter((appt) => {
          return appt.report_date >= startDate && appt.report_date <= endDate;
        });
      }
      
    else{
        this.filterreport.title = "APPOINTMENTS REPORT";
        this.fitered_array == this.AppointmentsReport;
    }
    },
  },
  computed: {
    ...mapGetters("appointment", ["AppointmentsReport", "Appointment_status"]),
    ...mapGetters("auth", ["user_permissions"]),
    /**
     * Total no. of records
     */
 statusId(){
   return this.filterreport.statuscode
 },
 start_date(){
   return this.filterreport.date1
 },
 end_date(){
   return this.filterreport.date2
 },
    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.fitered_array ? this.fitered_array.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.closeModal(this.model_id);
          this.resetApp();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    AppointmentsReport(newValue) {
      if (newValue.length > 0) {
        this.fill_report();
      }
    },

  statusId(){
   this.filter_report()
  },
  start_date(){
   this.filter_report()
  },
  end_date(){
   this.filter_report()
  }

  },
  created() {
    this.appointmentsFetch();
    this.FetchVillages();
    this.FetchReturningPatients();
    this.FetchCountries();
    this.FetchStaff();
    this.filter_report();
    this.fill_report();
  },
};
</script>

<template>
  <Layout> 
    <PageHeader :title="title" :items="items" />     
    <div class="row">
      <div class="col-12">      
        <div class="card">
          <div class="card-body">
              <h3 class="card-title mb-2 text-center" v-html="filterreport.title"></h3>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
               
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
               
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>STATUS</label>
                <select
                  v-model="filterreport.statuscode"
                  class="form-control m-1"
               
                  placeholder="Filter By Status"
                 
                >
                  <option value="">Select status</option>
                  <option value="Pending..">Pending</option>
                  <option value="Done">Done</option>
                  <option value="Canclled">Cancelled</option>
                </select>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="fitered_array ? fitered_array : []"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(name)="data">
                  <router-link
                    v-if="user_permissions.client_profile"
                    class="btn btn-link btn-sm"
                    :to="{
                      name: 'PatientProfile',
                      params: { patient_id: data.item.patient.id },
                    }"
                  >
                    {{ data.item.patient.patient_name }}
                  </router-link>
                </template>

                <template #cell(photo)="data">
                  <div class="text-lg-center">
                    <div
                      class="avatar-sm me-3 mx-lg-auto mb-3 mt-1 float-start float-lg-none"
                    >
                      <span
                        class="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-16"
                      >
                        {{ data.item.short }}
                      </span>
                    </div>
                  </div>
                </template>
              </b-table>
              <h3 v-if="!this.AppointmentsReport" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
